import { combineReducers } from 'redux'

import changePasswordSlice from './FormChangePassword/reducer'
import contactInfoSlice from './FormContactInfo/reducer'
import customBenefitPaymentSlice from './FormCustomBenefitPayment/reducer'
import goPaySlice from './FormGoPay/reducer'
import lostCardSlice from './FormLostCard/reducer'
import registerClubSlice from './FormRegisterClub/reducer'

export default combineReducers({
    changePassword: changePasswordSlice,
    contactInfo: contactInfoSlice,
    lostCard: lostCardSlice,
    registerClub: registerClubSlice,
    goPay: goPaySlice,
    benefitPayment: customBenefitPaymentSlice,
})
